import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['sidebar', 'bg']

  connect() {
    // If nav link has a redirect class, change the data-action to expand
    // if nav link has no redirect class and not a hash, change the data-action to close
    let links = this.sidebarTarget.querySelectorAll('a')
    links.forEach((link) => {
      if (link.classList.contains('nav-link--redirect')) {
        link.dataset.action = 'navigation#expand'
      } else if (link.getAttribute('href') !== '#') {
        link.dataset.action = 'navigation#close'
      }
    })

    this.bodyElement = document.body
  }

  expand(event) {
    if (this.sidebarTarget.classList.contains('is-open')) {
      event.preventDefault()
      let link = event.currentTarget
      if (!link.classList.contains('nav-link--is-selected')) {
        let list = link.nextElementSibling
        list.classList.toggle('hidden')
      }
    }
  }

  toggle() {
    if (this.sidebarTarget.classList.contains("is-open")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.bodyElement.setAttribute("data-lock-scrolling", "")
    this.bgTarget.classList.remove("hidden")
    this.sidebarTarget.classList.add("is-transitioning")
    setTimeout(() => {
      this.sidebarTarget.classList.add("is-open")
    }, 10)
    this.sidebarTarget.addEventListener("transitionend", () => {
      this.sidebarTarget.classList.remove("is-transitioning")
    }, { once: true })
  }

  close() {
    if (this.sidebarTarget.classList.contains("is-open")) {
      this.bodyElement.removeAttribute("data-lock-scrolling")
      this.bgTarget.classList.add("hidden")
      this.sidebarTarget.classList.add("is-transitioning")
      this.sidebarTarget.classList.remove("is-open")
      this.sidebarTarget.addEventListener("transitionend", () => {
        this.sidebarTarget.classList.remove("is-transitioning")
      }, { once: true })
    }
  }
}
